module.exports = __webpack_public_path__ + "img/copy-icon.a13325de.svg";